import { NgModule } from '@angular/core';
import { FeatureFlagDirective } from 'src/app/core/feature-flags/feature-flag.directive';
import { FeatureFlagService } from 'src/app/core/feature-flags/feature-flag.service';

@NgModule({
  declarations: [FeatureFlagDirective],
  imports: [],
  providers: [FeatureFlagService],
  exports: [FeatureFlagDirective],
})
export class FeatureFlagModule {}
